import React, { useEffect, useState } from 'react';
import { Input, Button, Typography, Form } from 'antd';
import GenericModal from "../../../../components/buttons/genericModal";
import Box from '@mui/material/Box';
import { backendPatchWithoutRefresh, backendPostWithoutRefresh } from '../../../../helpers/callBackend';

const ConnectionManagementProtocolModal = (props) => {
  const [protocolModalVisible, setProtocolModalVisible] = useState(false);
  const [protocolIsEditing, setProtocolIsEditing] = useState(false);
  const [protocolSaveLoading, setProtocolSaveLoading] = useState(false);
  const [protocolForm] = Form.useForm();

  const showProtocolModal = () => {
    setProtocolModalVisible(true);
  };

  const handleProtocolModalCancel = () => {
    setProtocolModalVisible(false);
    setProtocolIsEditing(false);
    protocolForm.resetFields();
  };

  const handleProtocolEdit = () => {
    setProtocolIsEditing(true);
    protocolForm.setFieldsValue({ protocol: props.protocolText });
  };

  const handleProtocolEditCancel = () => {
    setProtocolIsEditing(false);
    protocolForm.resetFields();
  };

  const handleProtocolSave = () => {
    protocolForm.validateFields()
      .then(values => {
        
        backendPatchWithoutRefresh(
          "/api/external-connections/settings/",
          {
            source_group_id: props.sourceGroupId,
            source: props.source,
            description: values.protocol,
          }
        ).then((res) => {
          props.setProtocolText(res?.data?.data?.settings?.description);
          setProtocolIsEditing(false);
          setProtocolSaveLoading(false);
        })
      })
      .catch(info => {
        console.error('Validate Failed:', info);
      });
  };

  const ProtocolContent = () => (
    <>
      {protocolIsEditing ? (
        <Form
          form={protocolForm}
          layout="vertical"
          initialValues={{ protocol: props.protocolText }}
        >
          <Form.Item 
            name="protocol" 
            rules={[{ required: true, message: 'Please input the protocol content' }]}
          >
            <Input.TextArea
              rows={5}
              placeholder="Add a connection management protocol here. For example, it may be to contact a specific email at your bank."
            />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0, textAlign: 'left' }}>
            <Button onClick={handleProtocolEditCancel} style={{ marginRight: 8 }}>
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={handleProtocolSave}
              loading={protocolSaveLoading}
            >
              Save
            </Button>
          </Form.Item>
        </Form>
      ) : (
        <>
          <div
            style={{
              padding: 16,
              backgroundColor: '#f5f5f5',
              marginBottom: 16,
              minHeight: '120px',
              borderRadius: 4
            }}
          >
            {props.protocolText ? (
              <Typography.Text>
                {props.protocolText}
              </Typography.Text>
            ) : (
              <Typography.Text type="secondary" italic>
                Add a connection management protocol here. For example, it may be to contact a specific email at your bank.
              </Typography.Text>
            )}
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-begin' }}>
            <Button type="primary" onClick={handleProtocolEdit}>
              Edit
            </Button>
          </div>
        </>
      )}
    </>
  );

  return (
    <Box>
      <GenericModal
        button={<span style={{ color: '#1890ff', cursor: 'pointer' }}>Connection Management Protocol →</span>}
        showModal={showProtocolModal}
        visible={protocolModalVisible}
        handleCancelModal={handleProtocolModalCancel}
        modalTitle={`Connection Manage Protocol for ${props.institutionName || 'Institution'}`}
        modalBody={<ProtocolContent />}
        size="md"
      />
    </Box>
  );
};

export default ConnectionManagementProtocolModal;